import { Calendar } from "lucide-react";
import { Link } from "react-router";
import { getTranslationFn } from "../../i18n";
import type { Locale } from "../../lib/locale";
import { Button } from "../ui/button";

interface MarketingCtaProps {
  locale: Locale;
}

export function MarketingCta({ locale }: MarketingCtaProps) {
  const t = getTranslationFn(locale);

  return (
    <section className="py-24 md:py-32 bg-brand-900">
      <div className="container mx-auto px-4 text-center max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-white leading-[1.1]">
          {t("Landing.cta.title")}
        </h2>
        <p className="mt-8 text-xl text-brand-200/70 font-light leading-relaxed">
          {t("Landing.cta.description")}
        </p>
        <div className="mt-12">
          <Button
            size="lg"
            asChild
            className="h-14 px-10 text-base font-medium rounded-full bg-white text-brand-900 shadow-2xl shadow-black/20 hover:shadow-black/30 transition-all hover:-translate-y-0.5 hover:bg-brand-50"
          >
            <Link to="mailto:hello@anylawyer.com">
              {t("Landing.cta.secondaryCta")}
              <Calendar className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
